import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.TABS_ROUTES),
  },
  {
    path: 'dev',
    loadChildren: () => import('./pages/dev/dev.routes').then((m) => m.DEV_ROUTES),
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.routes').then((m) => m.LOGIN_ROUTES),
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'auto-selling',
    loadChildren: () => import('./pages/auto-selling/auto-selling.routes').then((m) => m.AUTO_SELLING_ROUTES),
    canMatch: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/terms/terms.routes').then((m) => m.TERMS_ROUTES),
  },
  {
    path: 'question/1',
    loadChildren: () => import('./pages/questions/personal-problem/personal-problem.routes').then((m) => m.PERSONAL_PROBLEM_ROUTES),
  },
  {
    path: 'question/2',
    loadChildren: () => import('./pages/questions/city-problem/city-problem.routes').then((m) => m.CITY_PROBLEM_ROUTES),
  },
  {
    path: 'question/3',
    loadChildren: () => import('./pages/questions/cause-problem/cause-problem.routes').then((m) => m.CAUSE_PROBLEM_ROUTES),
  },
  {
    path: 'signup-start',
    loadChildren: () => import('./pages/signup-start/signup-start.routes').then((m) => m.SIGNUP_START_ROUTES),
  },
  {
    path: 'signup-end',
    loadChildren: () => import('./pages/signup-end/signup-end.routes').then((m) => m.SIGNUP_END_ROUTES),
  },
  {
    path: 'edit-public-profile',
    loadChildren: () =>
      import('./pages/public-figure-profile/update-public-profile/update-public-profile.routes').then(
        (m) => m.UPDATE_PUBLIC_PROFILE_ROUTES
      ),
    canMatch: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'edit-public-profile/:publicFigureKey',
    loadChildren: () =>
      import('./pages/public-figure-profile/update-public-profile/update-public-profile.routes').then(
        (m) => m.UPDATE_PUBLIC_PROFILE_ROUTES
      ),
    canMatch: [AuthGuard],
    canActivate: [AuthGuard],
  },
];
